import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface PropertyMapProps {
  latitude: string | number;
  longitude: string | number;
  title?: string;
  zoom?: number;
}

const PropertyMap: React.FC<PropertyMapProps> = ({ 
    latitude, 
    longitude, 
    title, 
    zoom = 15 
}) => {
  const { t } = useTranslation();
  const mapTitle = title || t('properties.addEdit.pageTexts.form.propertyMap.title');
  const lat = parseFloat(String(latitude));
  const lng = parseFloat(String(longitude));

  const isValid = !isNaN(lat) && !isNaN(lng) && (lat !== 0 || lng !== 0);

  if (!isValid) {
      return (
          <div style={{ height: '100%', width: '100%', background: '#f0f0f0', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '0.375rem' }}>
              {t('properties.addEdit.pageTexts.form.propertyMap.placeholder')}
          </div>
      );
  }

  const mapUrl = `https://maps.google.com/maps?q=${lat},${lng}&z=${zoom}&output=embed`;

  return (
    <div style={{ height: '100%', width: '100%' }}>
      <iframe
        src={mapUrl}
        width="100%"
        height="100%"
        style={{ border: 0, borderRadius: '0.375rem' }}
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        title={mapTitle}
      ></iframe>
    </div>
  );
};

export default PropertyMap;
